module.exports = __webpack_public_path__ + "static/media/warning_icon.b845218a.svg";